import { driverColumns } from "../../../Data/Driver/DriverListing";
import React, { Fragment, useContext, useState } from "react";
import ActionOptions from "../../Common/Component/ActionOptions";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import AssignBooking from "../AssignBooking";
import LocateDriver from "../LocateDriver";
import NotifyDriver from "../NotifyDriver";
import QuickActions from "./QuickActions";
import BlockDriver from "../BlockDriver";
import ResetDriver from "../ResetDriver";
import UnblockConformation from "../UnblockConformation";
import { Spinner } from "../../../AbstractElements";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import RechargeModal from "./RechargeModal";
import { getUserRole } from "../../../Services/Shared.service";
import { DropdownItem } from "reactstrap";
import { Accountant, AirportAgent } from "../../../Data/SideMenu/RouteMapping";
import RetrieveConfirmationModal from "./RetrieveConfirmationModal";
import CustomizerContext from "../../../_helper/Customizer";
const DriverListTable = ({
  driverData,
  paginationPerPage,
  paginationTotalRows,
  onChangePage,
  onChangeRowsPerPage,
  setShowApiLoader,
  globalCityField,
  fetchDriverData,
  setPageNumber,
  pagination,
  pageNumber,
  loader,
  filterData,
  searchData,
  setEditId,
  toggleCreateDriverModal
}) => {
  const [assignBookingModal, setAssignBookingModal] = useState(false);
  const toggleAssignBookingModal = () =>
    setAssignBookingModal(!assignBookingModal);

  const [locateDriverModal, setLocateDriverModal] = useState(false);
  const toggleLocateDriverModal = () =>
    setLocateDriverModal(!locateDriverModal);

  const [unblockModal, setUnblockModal] = useState(false);
  const toggleUnblockModal = () =>
    setUnblockModal(!unblockModal);

  const [notifyDriverModal, setNotifyDriverModal] = useState(false);
  const toggleNotifyDriverModal = () =>
    setNotifyDriverModal(!notifyDriverModal);

  const [blockDriverModal, setBlockDriverModal] = useState(false);
  const toggleBlockDriverModal = () => setBlockDriverModal(!blockDriverModal);

  const [resetDriverModal, setResetDriverModal] = useState(false);
  const toggleResetDriverModal = () => setResetDriverModal(!resetDriverModal);
  const [driverObj, setDriverObj] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () =>
    setDeleteModal(!deleteModal);
  const [rechargeModal, setRechargeModal] = useState(false);
  const toggleRechargeModal = () =>
    setRechargeModal(!rechargeModal);
  const [retrieveModal, setRetrieveModal] = useState(false);
  const toggleRetrieveModal = () =>
    setRetrieveModal(!retrieveModal);

  const userRole = getUserRole()
  const {mix_background_layout} = useContext(CustomizerContext)
  const processData = driverData.map((element, index) => {
    return {
      full_name: (
        <Link
          to={`${process.env.PUBLIC_URL}/driver/driver-info/${element.id}`}
          onClick={() => setPageNumber(pagination)}
          state={{ previousUrl: window.location.pathname, filterdata: filterData, searchdata: searchData }}
        >
          {element.fullName}
        </Link>
      ),
      phone_number: element.mobile,
      // status: element.status ? (
      //   <div className="driver-status online">{element.status}</div>
      // ) : (
      //   "-"
      // ),
      driver_type: element.isPrimary ? "Primary" : "Secondary",
      subscription: element.subscription,
      isAvailable: element?.isDeleted ? (
        <span className="driver-availability driver-blocked">Deleted</span>
      ) : element?.isAvailable ? (
        <span className="driver-availability driver-available">Available</span>
      ) :element?.isLeave ? ( <span className="driver-availability driver-blocked">On Leave</span>): (
        <span className="driver-availability driver-blocked">Blocked</span>
      ),
      blockedReason:element.blockedReason? element.blockedReason:'-',
      isDeleted: element?.isDeleted ? true : false,
      cab_number: element.mainCabNo,
      current_ride: element.current_ride,
      action: (
        element?.isDeleted ? (<ActionOptions >
          <DropdownItem
            className="border-0"
            key={"row-edit"}
            onClick={() => {
              setDriverObj(element);
              toggleRetrieveModal()
            }}
          >
            <i className="fa fa-mail-forward"></i> Retrieve
          </DropdownItem>
        </ActionOptions>)
          : (<ActionOptions >
            {userRole.some((element) => element != Accountant) ?
              <QuickActions
                key={index}
                element={element}
                setDriverObj={setDriverObj}
                toggleAssignBookingModal={toggleAssignBookingModal}
                toggleLocateDriverModal={toggleLocateDriverModal}
                toggleNotifyDriverModal={toggleNotifyDriverModal}
                toggleBlockDriverModal={toggleBlockDriverModal}
                toggleResetDriverModal={toggleResetDriverModal}
                toggleUnblockModal={toggleUnblockModal}
                setEditId={setEditId}
                toggleCreateDriverModal={toggleCreateDriverModal}
                toggleDeleteModal={toggleDeleteModal}
                toggleRechargeModal={toggleRechargeModal}
              /> :
              <DropdownItem
                className="border-0"
                key={"row-edit"}
                onClick={() => {
                  setDriverObj(element);
                  toggleRechargeModal()
                }}
              >
                <i className="fa fa-rupee"></i> Recharge
              </DropdownItem>}
          </ActionOptions>)
      ),
    };
  });

  const conditionalRowStyles = [
    {
      when: row => row.isDeleted == true,
      style: {
        backgroundColor: '#F9B5A6',
      },
    },
    // {
    //   when: row => row.isDeleted == false,
    //   style: {
    //     backgroundColor: 'white',
    //   },
    // },
  ];
  return (
    <div className="driver-table">
      <div className="table-responsive driver-list">
        {/* <CommonDataTable options={{
                    columns:driverColumns,
                    data:processData,
                    center:true
                }}
                /> */}
        <DataTable
          columns={userRole.some((element) => element != AirportAgent) ? driverColumns : driverColumns.slice(0, driverColumns.length - 1)}
          data={processData}
          conditionalRowStyles={conditionalRowStyles}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationDefaultPage={pageNumber}
          paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          progressPending={loader}
          progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
      <AssignBooking
        LargeModaltoggle={toggleAssignBookingModal}
        title={"Assign Booking"}
        Large={assignBookingModal}
        setShowApiLoader={setShowApiLoader}
        assignBookingDriverObj={driverObj}
        globalCityField={globalCityField}
      />
      <LocateDriver
        LargeModaltoggle={toggleLocateDriverModal}
        title={"Locate Driver"}
        Large={locateDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
      />
      <NotifyDriver
        LargeModaltoggle={toggleNotifyDriverModal}
        title={"Push Notification"}
        Large={notifyDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
      />
      <BlockDriver
        LargeModaltoggle={toggleBlockDriverModal}
        title={"Block Driver"}
        Large={blockDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
        fetchDriverData={fetchDriverData}
      />
      <UnblockConformation
        LargeModaltoggle={toggleUnblockModal}
        title={"Unblock"}
        Large={unblockModal}
        driverObj={driverObj}
        fetchDriverData={fetchDriverData}
      />
      <ResetDriver
        LargeModaltoggle={toggleResetDriverModal}
        title={"Confirm Driver Reset"}
        Large={resetDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
      />
      <DeleteConfirmationModal
        Large={deleteModal}
        title={"Delete Driver"}
        LargeModaltoggle={toggleDeleteModal}
        fetchData={fetchDriverData}
        driverObj={driverObj}
      />
      <RetrieveConfirmationModal
        Large={retrieveModal}
        title={"Retrieve Driver"}
        LargeModaltoggle={toggleRetrieveModal}
        fetchData={fetchDriverData}
        driverObj={driverObj}
        filterData={filterData}
        searchData={searchData}
      />
      <RechargeModal
        Large={rechargeModal}
        title={"Recharge Driver"}
        LargeModaltoggle={toggleRechargeModal}
        fetchData={fetchDriverData}
        driverObj={driverObj}
      />
    </div>
  );
};
export default DriverListTable;
